export default __webpack_public_path__ + "static/media/Newsfeed-NewPost.84ecd356.svg";